import { useNetworkStore } from '@/lib/network-status';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  const isOnline = useNetworkStore((s) => s.isOnline);
  if (isOnline) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[100] flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-xs font-bold text-amber-950 shadow-md">
      <WifiOff className="h-3.5 w-3.5" />
      You're offline — showing cached data
    </div>
  );
}
